import React, {useEffect, useState} from "react";
import {Calendar} from "react-big-calendar";
import moment from "moment";
import 'moment/locale/de';

import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import WeexWeek from "./WeexWeek";
import WeexWeekProgram from "./WeexWeekProgram";
import WeexDay from "./WeexDay";
import WeexDayProgram from "./WeexDayProgram";
import {weexLocalizer} from "../../App";
import WeexCalendar from "./WeexCalendar";
import logo from "../../img/Logo.png"
import WeexCalendarGrid from "./WeexCalendarGrid";

moment.updateLocale('de', {
    week: {
        dow: 1 // Montag ist der erste Tag der Woche
    }
});

export default function Calender({isSchedulePlaner = true, ...props}){
    const isSmallScreen = window.innerWidth < 1096;
    const [view, setView] = useState(isSmallScreen && isSchedulePlaner !== null ? "day" : "week");
    const [currentDate, setCurrentDate] = useState(new Date());
    const [toolbar, setToolbar] = useState(true);
    const [isGrid, setIsGrid] = useState(false);

  useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const grid = queryParams.get('grid');
      if(grid) setIsGrid(grid === "true");
    }, [])

    return (
        <div {...props} style={{backgroundColor: isGrid?"#0d0e0f":undefined}}>
            {isSchedulePlaner == null&&!isGrid&&<div className={"calendar-header"}>
              <h1>Kurskalender</h1>
              <a href={"https://weexplan.com"} style={{display: "flex", flexDirection: "row", alignItems: "baseline", gap: 2, marginTop: "-1.5rem"}}>
                <div style={{fontSize: "0.75rem", opacity: 0.33}}>powered by</div>
                <img alt={"logo"} src={logo} style={{height: "1.2rem", transform: "translateY(4px)", opacity: 0.5}}/>
              </a>
            </div>}
          <Calendar
            localizer={weexLocalizer}
            events={null}
            toolbar={isGrid ? null : toolbar}
            messages={{
                    next: isSchedulePlaner == null ? "+1 Woche" : "->",
                    previous: isSchedulePlaner == null ? "-1 Woche" : "<-",
                    today: "Heute",
                    day: "Tag",
                    week: "Woche"
                }}
                // components = {{toolbar: props => (<ToolBarView {...props} timesheetDate={timesheetDate}/>)} }
                view={view}
                onView={setView}
                views={{
                    day: isSchedulePlaner === true ? WeexDay : isSchedulePlaner === false ? WeexDayProgram : false,
                    week: isSmallScreen && isSchedulePlaner != null ? false : isSchedulePlaner === true ? WeexWeek : isSchedulePlaner === false ? WeexWeekProgram : isGrid? WeexCalendarGrid: WeexCalendar,
                    month: false,
                    agenda: false
                }}
                date={currentDate}
                onNavigate={(newDate) => setCurrentDate(newDate)}
                setCurrentDate={setCurrentDate}
                setToolbar={setToolbar}
            />
          {isGrid &&
            <a href={"https://weexplan.com"}
               style={{display: "flex", flexDirection: "row", alignItems: "baseline", gap: 2}}>
              <div style={{fontSize: "0.75rem", opacity: 0.33}}>powered by</div>
              <img alt={"logo"} src={logo} style={{height: "1.2rem", transform: "translateY(4px)", opacity: 0.5}}/>
            </a>}
        </div>
    );
};

